function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAppResolutions } from "@common/actions";
import SettingItem from "@common/components/Settings/SettingItem";
import SettingsModalContentWrapper from "@common/components/Settings/SettingsModalContentWrapper";
import { changeWebSetting } from "@common/utils/helpers";
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
var VideoSettings = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(VideoSettings, SettingItem);
    var _super = _create_super(VideoSettings);
    function VideoSettings(props) {
        _class_call_check(this, VideoSettings);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "onChangeHandler", function(event) {
            var _this_props = _this.props, onChangeHandler = _this_props.onChangeHandler, profileSettings = _this_props.profileSettings;
            var resolution = Number.parseInt(event.target.value);
            _this.setState({
                resolution: resolution
            });
            onChangeHandler(changeWebSetting(profileSettings, {
                resolution: resolution
            }));
        });
        _define_property(_assert_this_initialized(_this), "getAvailableResolitions", function() {
            var settingsResolutionsConfig = _this.props.settingsResolutionsConfig;
            return Object.keys(_this.resolutionsMap).filter(function(resolution) {
                return settingsResolutionsConfig.data.includes(resolution);
            }).reduce(function(obj, key) {
                obj[key] = _this.resolutionsMap[key];
                return obj;
            }, {});
        });
        _define_property(_assert_this_initialized(_this), "renderLabels", function() {
            return _this.resolutionsMap.map(function(resolution, index) {
                var formControlLabelStyle = {
                    width: "100%",
                    marginTop: 4,
                    marginBottom: 4
                };
                var label = /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body1",
                            style: {
                                fontSize: "1.6rem"
                            },
                            component: "div",
                            children: resolution.title
                        }, "video-resolution-title-".concat(index)),
                        resolution.desciption && /*#__PURE__*/ _jsx(Typography, {
                            variant: "body1",
                            style: {
                                color: "grey",
                                fontSize: "1.3rem"
                            },
                            children: resolution.desciption
                        }, "video-resolution-desciption-".concat(index))
                    ]
                });
                return /*#__PURE__*/ _jsx(FormControlLabel, {
                    value: resolution.value,
                    style: formControlLabelStyle,
                    className: "border-wrapper",
                    control: /*#__PURE__*/ _jsx(Radio, {}),
                    label: label
                }, "video-resolution-".concat(index));
            });
        });
        var _this_props_i18n = _this.props.i18n, i18nSettings = _this_props_i18n.settings;
        // Here we define all available video settings
        _this.resolutionsMap = [
            {
                title: i18nSettings.auto,
                desciption: null,
                value: -1
            },
            {
                title: i18nSettings.resolution1080,
                desciption: i18nSettings.resolution1080desc,
                value: 1080
            },
            {
                title: i18nSettings.resolution720,
                desciption: i18nSettings.resolution720desc,
                value: 720
            },
            {
                title: i18nSettings.resolution576,
                desciption: i18nSettings.resolution576desc,
                value: 576
            },
            {
                title: i18nSettings.resolution432,
                desciption: i18nSettings.resolution432desc,
                value: 432
            },
            {
                title: i18nSettings.resolution288,
                desciption: i18nSettings.resolution288desc,
                value: 288
            }
        ];
        _this.initialResolution = _this.props.profileSettings.web_settings.resolution;
        _this.state = {
            resolution: _this.initialResolution
        };
        return _this;
    }
    _create_class(VideoSettings, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                _get(_get_prototype_of(VideoSettings.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.getAppResolutions();
            }
        },
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(SettingsModalContentWrapper, {
                    title: i18n.settings.controlVideos,
                    children: /*#__PURE__*/ _jsx(FormControl, {
                        fullWidth: true,
                        margin: "normal",
                        children: /*#__PURE__*/ _jsx(RadioGroup, {
                            "aria-label": "video-resolutions-group",
                            name: "video-resolutions",
                            value: this.state.resolution,
                            onChange: this.onChangeHandler,
                            children: this.renderLabels()
                        })
                    })
                });
            }
        }
    ]);
    return VideoSettings;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings, settingsResolutionsConfig = param.settingsResolutionsConfig;
    return {
        i18n: i18n,
        profileSettings: profileSettings,
        settingsResolutionsConfig: settingsResolutionsConfig
    };
};
export default connect(mapStateToProps, {
    getAppResolutions: getAppResolutions
})(VideoSettings);
